// src/components/OptionsSection.js
import React from 'react';
import { Typography, Box } from '@mui/material';
import { FaHandshake, FaTasks, FaMapMarkedAlt } from 'react-icons/fa';

const options = [
  {
    title: 'Personal Guidance',
    description:
      "We don't just open doors. We help you evaluate neighborhoods, school districts, and long-term value.",
    icon: <FaHandshake size={32} color="#fff" />,
  },
  {
    title: 'Process Management',
    description:
      'From inspections to closing paperwork, we handle the logistics so you can focus on your life, not the stress.',
    icon: <FaTasks size={32} color="#fff" />,
  },
  {
    title: 'Local Roots',
    description:
      'We live here. We know the Troy, Auburn Hills, and Novi markets because they are our home too.',
    icon: <FaMapMarkedAlt size={32} color="#fff" />,
  },
];

const OptionsSection = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '60px 20px',
      backgroundColor: 'transparent',
    }}
  >
    {/* Heading Section */}
    <Typography
      variant="h4"
      component="h2"
      gutterBottom
      sx={{
        color: '#333333',
        textAlign: 'center',
        marginBottom: '50px',
        fontWeight: 'bold',
      }}
    >
      Why choose Ganesh?
    </Typography>

    {/* Timeline Container */}
    <Box
      sx={{
        position: 'relative',
        maxWidth: '800px',
        width: '100%',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: { xs: '20px', md: '50%' },
          transform: { xs: 'none', md: 'translateX(-50%)' },
          width: '3px',
          height: '100%',
          background: 'linear-gradient(180deg, #1a365d, #c9302c, #1a365d)',
          borderRadius: '2px',
        },
      }}
    >
      {options.map((option, index) => (
        <Box
          key={option.title}
          sx={{
            display: 'flex',
            flexDirection: { xs: 'row', md: index % 2 === 0 ? 'row' : 'row-reverse' },
            alignItems: 'flex-start',
            marginBottom: '40px',
            position: 'relative',
          }}
        >
          {/* Timeline Node */}
          <Box
            sx={{
              position: 'absolute',
              left: { xs: '20px', md: '50%' },
              transform: 'translateX(-50%)',
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1a365d, #2c4a7c)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(26, 54, 93, 0.4)',
              zIndex: 2,
            }}
          >
            {option.icon}
          </Box>

          {/* Content Card */}
          <Box
            sx={{
              width: { xs: 'calc(100% - 70px)', md: 'calc(50% - 50px)' },
              marginLeft: { xs: '60px', md: index % 2 === 0 ? '0' : 'auto' },
              marginRight: { xs: '0', md: index % 2 === 0 ? 'auto' : '0' },
              paddingLeft: { md: index % 2 === 0 ? '0' : '50px' },
              paddingRight: { md: index % 2 === 0 ? '50px' : '0' },
            }}
          >
            <Box
              sx={{
                background: '#fff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                border: '1px solid #e0e0e0',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  color: '#1a365d',
                  marginBottom: '8px',
                }}
              >
                {option.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#555',
                  lineHeight: 1.6,
                }}
              >
                {option.description}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);

export default OptionsSection;
